import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const RevealAnimationSection = ({ children, style, direction = "right" }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const initialX = direction === "left" ? -150 : 150;

  return (
    <motion.div
      className="mx-auto max-w-[1320px]"
      style={style}
      ref={ref}
      initial={{ x: initialX, opacity: 0 }}
      animate={inView ? { x: 0, opacity: 1 } : {}}
      transition={{ duration: 1.5, ease: "linear" }}
    >
      {children}
    </motion.div>
  );
};

export default RevealAnimationSection;
